/* Core & libraries */
import React, { useEffect, useState } from "react";
import { useTheme } from "react-jss";
import { Animated } from "react-animated-css";

/* Helpers, constants, custom methods, internal libraries */
import { useIsMobile } from "../../hooks/useIsMobile";
import { useUserContext } from "../../contexts/userContext";
import { isAdmin } from "../../helpers/general";
import { AIRLINES } from "../../constants/appConstants";

/* Components */
import LogoSwitcher from "../logoSwitcher";
import NavigationItems from "../navigationItems";
import NavigationFooter from "../navigationFooter";
import ToggleMenu from "./toggleMenu";

/* Styles */
import styles from "./styles.js"
import stylesSwitcher from "../logoSwitcher/styles"

const Navigation = ({ bannerResponse, bannerDisplay, bannersHeight }) => {
  const theme = useTheme();
  const classes = styles({ theme });
  const classesSwitcher = stylesSwitcher({ theme });
  const isMobile = useIsMobile();

  const userContext = useUserContext();
  const adminUser = isAdmin(userContext);
  
  const providerCode = userContext?.userInfo?.providerInfo?.providerCode;
  const showLogoDivider = providerCode === AIRLINES.CHOICE;

  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false)
  const [animations, setAnimations] = useState({
    animationIn: "",
    animationOut: "",
    isVisible: false,
  })

  useEffect(() => {
    setAnimations({
      animationIn: "",
      animationOut: "",
      isVisible: !isMobile,
    })
    if (!isMobile) {
      const item = document.querySelector("#navigation .fadeInRight")
      if (item) {
        item.classList.remove("bounceInRight")
      }
    }
  }, [isMobile])

  useEffect(() => {
    if (isMobile) {
      setIsMobileNavOpen(animations.isVisible)
      if (animations.isVisible) {
        const item = document.querySelector("#navigation .fadeInRight")
        if (item) {
          item.style.opacity = "1";
        }
      } else {
        const item = document.querySelector("#navigation .fadeOutRight")
        if (item) {
          setTimeout(() => {
            item.classList.remove("fadeOutRight")
            item.style.opacity = "0";
          }, 1000);
        }
      }
    }
  }, [animations.isVisible])

  useEffect(() => {
    if (isMobileNavOpen) {
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";

      //edge case where the actual page has less content
      if (document.documentElement.scrollHeight < 900) {
        document.querySelectorAll('[data-testid=navigationfooter]').forEach(element => {
          element.style.marginTop = '0';
        });
      }
    } else {
      document.documentElement.style.overflow = "auto";
    }

    return () => {
      document.documentElement.style.overflow = "auto";
      document.querySelectorAll('[data-testid=navigationfooter]').forEach(element => {
        element.style.marginTop = "auto";
      });
    };
  }, [isMobileNavOpen]);

  const handleToggleMenu = () => {
    if (isMobile) {
      setAnimations({
        animationIn: "fadeInRight",
        animationOut: "fadeOutRight",
        isVisible: !animations.isVisible
      })
    }
  }

  const clickOnLink = () => {
    if (isMobile) {
      setAnimations({
        animationIn: "",
        animationOut: "",
        isVisible: false,
      })
    }
  }

  return (
    <div id={"navigation"} className={`${classes.navigation} ${bannerResponse?.showBanner && bannerDisplay ? classes.bannerPresent : ""}`} data-testid="navigation">
      <ToggleMenu handleToggleMenu={handleToggleMenu} isMobileNavOpen={isMobileNavOpen} />
      <LogoSwitcher />
      {showLogoDivider && <hr className={classes.divider} />}
      <Animated
        key={"animated_menu"}
        className={`${classes.menuItems} ${bannerResponse?.showBanner && bannerDisplay ? classes.menuItemsBannerPresent : ""}`}
        animationIn={animations.animationIn}
        animationOut={animations.animationOut}
        isVisible={animations.isVisible}
        animationInDuration={500}
        animationOutDuration={400}
      >
        <NavigationItems isAdmin={adminUser} clickOnLink={clickOnLink} />
        <NavigationFooter isAdmin={adminUser} clickOnLink={clickOnLink} bannersHeight={bannersHeight} />
      </Animated>
    </div>
  )
}

export default Navigation;